import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import PengaduanAdminPanel from "layouts/pages/admin/pengaduan/components/PengaduanAdminPanel";
import { requireAuth } from "actions/AuthAction";

function AdminPengaduan() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!requireAuth(navigate, ["ADMIN", "SUPER_ADMIN"])) return undefined;
    return undefined;
  }, [navigate]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PengaduanAdminPanel title="Kelola Pengaduan & Masukan" />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AdminPengaduan;
